export class Client {
    ClientId: number;
    ClientName: string;
}
